import data from "../../.sourceflow/job_roles.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const seo_jobs_helper = new CollectionHelper(data);
